<template>
  <!-- BEGIN pos-counter-content -->
  <div class="pos-counter-content">
    <vue-custom-scrollbar class="pos-counter-content-container">
      <ts-loading-banner :loading="tableFetching">
        <div class="table-row">
          <TableCard v-for="(table, index) in tableLists" :key="index" :table="table"
            :selected="selected_table == table.table_id" @click="$emit('onTableSelected', table)"
            @member-checkout="$emit('onMemberCheckout', table)"
            @check-in="$emit('check-in', $event)"
            @pick-invoice="$emit('pick-invoice', $event)" />
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import TableCard from './TableCard.vue'

export default {
  name: 'PosCounterContent',
  components: {
    vueCustomScrollbar,
    TableCard
  },
  props: {
    tableLists: {
      type: Array,
      default: () => []
    },
    tableFetching: {
      type: Boolean,
      default: false
    },
    selected_table: {
      type: Number,
      default: 0
    }
  }
}
</script>